import { render, staticRenderFns } from "./NtkoViewSelector.vue?vue&type=template&id=bc95c522&scoped=true&"
import script from "./NtkoViewSelector.vue?vue&type=script&lang=js&"
export * from "./NtkoViewSelector.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bc95c522",
  null
  
)

export default component.exports